export const LEAD_MANAGEMENT_DATA_SUCCESS = "LEAD_MANAGEMENT_DATA_SUCCESS";
export const LEAD_MANAGEMENT_DATA_FAIL = "LEAD_MANAGEMENT_DATA_FAIL";
export const LEAD_MANAGEMENT_DATA = "LEAD_MANAGEMENT_DATA";

export const LEAD_MANAGEMENT_VIEW_SUCCESS = "LEAD_MANAGEMENT_VIEW_SUCCESS";
export const LEAD_MANAGEMENT_VIEW_FAIL = "LEAD_MANAGEMENT_VIEW_FAIL";
export const LEAD_MANAGEMENT_VIEW = "LEAD_MANAGEMENT_VIEW";

export const LEAD_MANAGEMENT_DETAILS = "LEAD_MANAGEMENT_DETAILS";
export const LEAD_MANAGEMENT_DETAILS_SUCCESS =
  "LEAD_MANAGEMENT_DETAILS_SUCCESS";
export const LEAD_MANAGEMENT_DETAILS_FAIL = "LEAD_MANAGEMENT_DETAILS_FAIL";

export const LEAD_MANAGEMENT_UPDATE_SUCCESS = "LEAD_MANAGEMENT_UPDATE_SUCCESS";
export const LEAD_MANAGEMENT_UPDATE_FAIL = "LEAD_MANAGEMENT_UPDATE_FAIL ";
export const LEAD_MANAGEMENT_UPDATE = "LEAD_MANAGEMENT_UPDATE";

export const LEAD_MANAGEMENT_LIST_ALL_SUCCESS =
  "LEAD_MANAGEMENT_LIST_ALL_SUCCESS";
export const LEAD_MANAGEMENT_LIST_PENDING_SUCCESS =
  "LEAD_MANAGEMENT_LIST_PENDING_SUCCESS";
export const LEAD_MANAGEMENT_LIST_COMPLETED_SUCCESS =
  "LEAD_MANAGEMENT_LIST_COMPLETED_SUCCESS";
export const LEAD_MANAGEMENT_LIST_DROPPED_SUCCESS =
  "LEAD_MANAGEMENT_LIST_DROPPED_SUCCESS";

export const LEAD_MANAGEMENT_CSV_START = "LEAD_MANAGEMENT_CSV_START";
export const LEAD_MANAGEMENT_CSV_SUCCESS = "LEAD_MANAGEMENT_CSV_SUCCESS";
export const LEAD_MANAGEMENT_CSV_ERROR = "LEAD_MANAGEMENT_CSV_ERROR";

export const LEAD_MANAGEMENT_REVIEW = "LEAD_MANAGEMENT_REVIEW";
export const LEAD_MANAGEMENT_REVIEW_SUCCESS = "LEAD_MANAGEMENT_REVIEW_SUCCESS";
export const LEAD_MANAGEMENT_REVIEW_FAIL = "LEAD_MANAGEMENT_REVIEW_FAIL";
